// extracted by mini-css-extract-plugin
export default {"container":"Part4_container__0N8YZ","infoBoxSingle":"Part4_infoBoxSingle__h6BH9","infoBox":"Part4_infoBox__I6g1J"};